export default "__VITE_ASSET__B4aX$0hb__"